module.exports = __webpack_public_path__ + "img/Carousel-Beneficios-icono-09.9ad9f08d.svg";